<div [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
    <div mat-dialog-title
      [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
      class="modal-header-bg d-flex justify-content-end px-3 pt-1">
    </div>
    <!-- <div class="stepper-overlay" *ngIf="!selectedAccount">
        <div class="overlay-content">
          {{ "choose-account" | translate }}
        </div>
      </div> -->
    <div mat-dialog-content [attr.dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'">
      <h4 class="font-weight-bold title-text">
        {{ "transfer-modal-title" | translate }}
        <img src="assets/img/transfer-icon.svg" alt="Transfer" class="transfer-icon">
      </h4>
      <!-- <p class="text-muted subtitle-text">{{ "withdrwal-modal-subtitle" | translate }}</p> -->
      
      <!-- Checkbox options -->
      <div class="d-flex justify-content-between">
        <div *ngFor="let option of options" class="checkbox-container" [class.selected-checkBox]="selectedOption === option.id" (click)="selectOption(option.id)">
          <div class="checkbox-wrapper">
            <input class="mx-2" type="checkbox" [id]="option.id" [checked]="selectedOption === option.id" (click)="($event.stopPropagation())" (change)="selectOption(option.id)" />
            <label (click)="($event.stopPropagation())" class="checkBox-label" [for]="option.id">{{ option.label }}</label>
          </div>
        </div>
      </div>
  
      <!-- Alert div -->
      <div class="alert-div alert-div-warning d-flex flex-wrap mt-2 mb-4">
        <div class="content-w mx-2 d-flex flex-column align-items-start">
          <div class="d-flex">
            <div class="icon-w">
              <img src="assets/img/ring.svg" alt="">
            </div>
            <span class="yellow-text mx-1 font-600">
              {{ "withdrwal-modal-alert-title" | translate }}  
            </span>
          </div>
          <span class="alert-desc-color font-small mx-4 text-start">
            {{ "withdrwal-modal-alert-text" | translate }}
          </span>
        </div>
      </div>
  
      <!-- First Form (Cash Transfer) -->
      <form #cashTransactionForm="ngForm" (ngSubmit)="submitCashTransfer(cashTransactionForm)" *ngIf="newWithdraw.ActionType == 2" class="col-md-12">
            <div class="row align-items-center">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label class="required form-field-title">{{"from-account"|translate}}</label>
                    <select id="FromAccount" #FromAccount="ngModel"
                      (change)="fetchPurchasePower(newCashTransfer.FromRelationCode)"
                      [(ngModel)]="newCashTransfer.FromRelationCode" name="FromAccount"
                      (change)="accountListValidation($event.target.value)" class="custom-select px-4" required>
                      <option *ngFor="let acc of userAccounts" value="{{acc?.relationCode}}">
                        ({{acc?.relationCode}})
                        {{(translate.currentLang=="en") ? acc.clientNameEn : acc.clientNameAr}}
                      </option>
                    </select>
                    <div *ngIf="FromAccount.touched && FromAccount.invalid" class="red">
                      <div *ngIf="FromAccount.errors.required">{{"acc-stock-err"|translate}}</div>
                    </div>
                  </div>
          
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label class="required form-field-title">{{"to-account"|translate}}</label>
                    <select id="ToAccount" name="ToAccount" #ToAccount="ngModel" class="custom-select px-4"
                      [(ngModel)]="newCashTransfer.ToRelationCode" required>
                      <option *ngFor="let acc of filteredUserAccounts()" value="{{acc?.relationCode}}">
                        ({{acc?.relationCode}})
                        {{(translate.currentLang=="en") ? acc?.clientNameEn : acc?.clientNameAr}}
                      </option>
                    </select>
                    <div *ngIf="ToAccount.touched && ToAccount.invalid" class="red">
                      <div *ngIf="ToAccount.errors.required">{{"acc-stock-err"|translate}}</div>
                    </div>
                  </div>
            </div>
  
          <!-- Currency and Amount fields -->
          <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="required form-field-title">{{"currency"|translate}}</label>
              <ng-select id="Currency" name="Currency" #Currency="ngModel" 
                (change)="fetchPurchasePower(newCashTransfer.FromRelationCode)" class="custom"
                ngModel required>
                <ng-option *ngFor="let curr of currencyList" [value]="curr">
                  {{(translate.currentLang=="en")?curr.CurrencyNameE:curr.CurrencyNameA}}
                </ng-option>
              </ng-select>
              <div *ngIf="Currency.touched && Currency.invalid" class="red">
                <div *ngIf="Currency.errors.required">{{"currency-err"|translate}}</div>
              </div>
            </div>
  
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="required form-field-title">{{"amount"|translate}}</label>
              <div>
                <input class="form-control"
                  [ngClass]="(translate.currentLang=='en')?'number-input': 'number-input-ar'"
                  type="text" ngModel #Amount="ngModel" id="Amount" name="Amount"
                  [(ngModel)]="newCashTransfer.Amount" number min="1" appTwoDigitDecimalNumber
                  appInputCommaSepreated required>
              </div>
  
              <span *ngIf="balanceAmount"
                [ngClass]="{'green':availableTransferBalance(cashTransactionForm) > 0, 'red': availableTransferBalance(cashTransactionForm)  < 0, 'grey': availableTransferBalance(cashTransactionForm)  == 0}">
                {{'availb-bal-transfer'|translate}} :
                {{availableTransferBalance(cashTransactionForm) | number}}
              </span>
              <div *ngIf="Amount.touched && Amount.invalid" class="red">
                <span *ngIf="Amount.errors.required">{{"amount-num-err"|translate}}</span>
                <span *ngIf="Amount.errors.pattern">{{"amount-decimal-err"|translate}}</span>
              </div>
            </div>
          </div>
  
          <!-- Submit button -->
          <div class="row px-2 mt-2" style="justify-content: end">
            <button class="btn btn-primary" type="submit" [disabled]="cashTransactionForm.invalid || newWithdraw.Amount > availableWithdrawBalance || isSubmitting || !selectedAccount">
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
              {{ "send" | translate }}
            </button>
          </div>
      </form>
      <!-- End of First Form -->
  
      <!-- Second Form (Stock Transfer) -->
      <form #stockTransactionForm="ngForm" (ngSubmit)="submitStockTransfer(stockTransactionForm)" *ngIf="newWithdraw.ActionType == 1" class="col-md-12">
        <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="required form-field-title">{{"from-account"|translate}}</label>
                <select id="FromAccount" #FromAccount="ngModel"
                  (change)="fetchPurchasePower(newCashTransfer.FromRelationCode)"
                  [(ngModel)]="newCashTransfer.FromRelationCode" name="FromAccount"
                  (change)="accountListValidation($event.target.value)" class="custom-select px-4" required>
                  <option *ngFor="let acc of userAccounts" value="{{acc?.relationCode}}">
                    ({{acc?.relationCode}})
                    {{(translate.currentLang=="en") ? acc.clientNameEn : acc.clientNameAr}}
                  </option>
                </select>
                <div *ngIf="FromAccount.touched && FromAccount.invalid" class="red">
                  <div *ngIf="FromAccount.errors.required">{{"acc-stock-err"|translate}}</div>
                </div>
              </div>
        
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="required form-field-title">{{"to-account"|translate}}</label>
                <select id="ToAccount" name="ToAccount" #ToAccount="ngModel" class="custom-select px-4"
                  [(ngModel)]="newCashTransfer.ToRelationCode" required>
                  <option *ngFor="let acc of filteredUserAccounts()" value="{{acc?.relationCode}}">
                    ({{acc?.relationCode}})
                    {{(translate.currentLang=="en") ? acc?.clientNameEn : acc?.clientNameAr}}
                  </option>
                </select>
                <div *ngIf="ToAccount.touched && ToAccount.invalid" class="red">
                  <div *ngIf="ToAccount.errors.required">{{"acc-stock-err"|translate}}</div>
                </div>
              </div>
        </div>
  
        <!-- Stock transfer fields -->
         <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                <label class="required form-field-title">{{ "stocks" | translate }}</label>
                <ng-select [searchable]="false" class="custom" ngModel name="SymbolCodes"
                  [dropdownPosition]="'bottom'" required [placeholder]="'stocks' | translate"
                  [formControl]="selectedSymbolControl">
                  <ng-option *ngFor="let stock of clientStocks" [value]="stock" > 
                    {{ translate.currentLang == "en" ? stock.SymbolNameEn : stock.SymbolNameAr }}
                  </ng-option>
                </ng-select>
                <div *ngIf="selectedSymbolControl.touched && selectedSymbolControl.invalid" class="red">
                    <div *ngIf="selectedSymbolControl.errors.required">{{"stock-err"|translate}}</div>
                  </div>
              </div>
        
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label class="required form-field-title">{{ "custodian" | translate }}</label>
                <ng-select [searchable]="true" class="custom" ngModel #CustodianCode="ngModel" name="CustodianCode"
                  required [dropdownPosition]="'bottom'">
                  <ng-option *ngFor="let Custodian of allCustod" [value]="Custodian">
                    ({{ Custodian.CustodianCode }}) {{ translate.currentLang == "en" ? Custodian.CustodianNameE : Custodian.CustodianNameA }}
                  </ng-option>
                </ng-select>
              </div>
         </div>

  
        <div class="col-md-6 mb-3 px-0">
          <label class="required form-field-title">{{ "stocks-quantity" | translate }}</label>
          <input [placeholder]="'withdraw-amount' | translate" [(ngModel)]="newWithdraw.Amount" #Amount="ngModel"
            name="Amount" type="text" class="form-control" required min="1" appTwoDigitDecimalNumber
            appInputCommaSepreated [ngClass]="translate.currentLang == 'en' ? 'number-input' : 'number-input-ar'" />
          <span *ngIf="availableWithdrawBalance != null" [ngClass]="{ green: availableWithdrawBalance > 0, red: availableWithdrawBalance < 0, grey: availableWithdrawBalance == 0 }">
            {{ "availb-bal" | translate }} :
            <strong *ngIf="availableWithdrawBalance % 1 != 0">{{ availableWithdrawBalance | number }}</strong>
            <strong *ngIf="availableWithdrawBalance % 1 == 0">{{ availableWithdrawBalance | number }}</strong>
          </span>
        </div>
  
        <!-- Submit button -->
        <div class="row px-2 mt-2" style="justify-content: end">
          <button class="btn btn-primary" type="submit" [disabled]="stockTransactionForm.invalid || newWithdraw.Amount > availableWithdrawBalance || isSubmitting || !selectedAccount">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
            {{ "send" | translate }}
          </button>
        </div>
      </form>
      <!-- End of Second Form -->
  
      <span class="info-warning">{{ "withdraw-note" | translate }}</span>
    </div>
  </div>
  